import { BiLogInCircle } from "react-icons/bi";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { useState } from 'react';
import './App.css';
import './Login.css'; // Importa o novo arquivo CSS
import { InputMask } from "primereact/inputmask";
import { FloatLabel } from 'primereact/floatlabel';
import { Password } from "primereact/password";
import eletropostoPic from './images/eletroposto.png';
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./auth/AuthProvider";
import { ProgressSpinner } from "primereact/progressspinner";
import { IoIosPersonAdd } from "react-icons/io";
import { BsKeyFill, BsPersonVcardFill } from "react-icons/bs";
import Panel from "./components/Panel";
import Title from "./components/Title";
import { Card } from "primereact/card";

function Login() {
  const [cpf, setCPF] = useState('')
  const [pass, setPass] = useState('')
  const navigate = useNavigate();
  const authenticator = useAuth()
  const [loading, setLoading] = useState(false)

  const login = async () => {
    setLoading(true)
    try {
      await authenticator.signin(cpf, pass, () => navigate('/home'))
    } catch (error) {
      console.error("Falha no login:", error);
      // Aqui seria um bom lugar para adicionar um Toast de erro para o usuário
    } finally {
      setLoading(false)
    }
  }

  const header = (
    <img src={eletropostoPic} alt="Eletroposto UFMS" style={{ width: '100%', height: 'auto' }} />
  );

  const footer = (
    <div className="login-footer" style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row', gap: '5px' }}>
      <Button severity='success' className="full-width-button" onClick={login} disabled={loading}  style={{ flexGrow: 1, flexBasis: '100px' }}>
        {loading ? <ProgressSpinner style={{ width: '24px', height: '24px' }} strokeWidth="8" /> :
          <>
            <BiLogInCircle size={24} style={{ marginRight: 5 }} />
            <div style={{ fontSize: 13, fontWeight: 'bold' }}>
              ACESSAR
            </div>
          </>}
      </Button>
      <Button severity='info' className="full-width-button" onClick={() => navigate('/signup')}  style={{ flexGrow: 1,  flexBasis: '100px' }}>
        <IoIosPersonAdd size={24} style={{ marginRight: 5 }} />
        <div style={{ fontSize: 13, fontWeight: 'bold' }}>
          CADASTRAR
        </div>
      </Button>
      <Button severity='secondary' className="full-width-button" onClick={() => navigate('/lostpass')} style={{ flexGrow: 1 ,  flexBasis: '100px' }}>
        <BsKeyFill size={24} style={{ marginRight: 5 }} />
        <div style={{ fontSize: 13, fontWeight: 'bold' }}>
          SENHA
        </div>
      </Button>
    </div>
  )

  const title = (
    <Title title="Eletroposto UFMS" subtitle="Acesso ao sistema" icon={() => <BiLogInCircle size={32} />} />
  )

  return (
    <div className="login-container">
      <Card title={title} footer={footer} header={header} className="login-panel" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center',  }}>
        <div className="p-inputgroup flex-1" style={{width: 320}}>
          <span className="p-inputgroup-addon">
            <BsPersonVcardFill />
          </span>
          <FloatLabel>
            <InputMask id="cpf_input" value={cpf} onChange={(e) => setCPF(e.target.value ?? '')} mask="999.999.999-99" />
            <label htmlFor="cpf_input">CPF</label>
          </FloatLabel>
        </div>

        <div className="p-inputgroup flex-1 input-group-container">
          <span className="p-inputgroup-addon">
            <BsKeyFill />
          </span>
          <Password
            inputId="pass_input"
            value={pass}
            onChange={(e) => setPass(e.target.value)}
            placeholder="Senha"
            toggleMask
            feedback={false}
            onKeyDown={(e) => e.key === 'Enter' && login()}

            pt={{ input: { style: { width: 270 } } }}
          // pt={{ input: { className: 'w-full' } }}
          // style={{ width: 100 }}

          // style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }} /* Ajusta as bordas do container */

          />
        </div>
      </Card>
    </div>
  );
}

export default Login;
